import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-picking-list-menu',
  templateUrl: './picking-list-menu.component.html',
  styleUrls: ['./picking-list-menu.component.scss']
})
export class PickingListMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
